import { AWS_STRAPI_JSON_DATA_FOLDER_NAME } from "@/utils/utils";

export async function getS3FileContent(
  pageName: string,
  isParse: boolean = true
): Promise<{ data: any } | string | null> {
  try {
    const cdnBaseUrl = process.env.DEV_CDN_URL;
    if (!cdnBaseUrl) {
      throw new Error("CDN URL is not defined. Please provide DEV_CDN_URL.");
    }

    const pageUrl = `${cdnBaseUrl}/${AWS_STRAPI_JSON_DATA_FOLDER_NAME}/${pageName}.json`;
    const response = await fetch(pageUrl);
    if (!response.ok) {
      if (response.status === 404) {
        return null; // File does not exist
      }
      throw new Error(`Failed to fetch file from CDN: ${response.statusText}`);
    }
    const dataInString = await response.text();
    return !isParse ? dataInString : JSON.parse(dataInString);
  } catch (err) {
    //@ts-expect-error - AWS S3 error handling
    if (err?.name === "NoSuchKey") {
      return null;
    }
    throw err;
  }
}